
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";


const PaymentSuccess = () => {

  const navigate = useNavigate();

  useEffect(() => {
    const redirectBackUrl = decodeURIComponent(
      document.cookie
        .split('; ')
        .find(row => row.startsWith('redirectBackUrl='))
        ?.split('=')[1] || ''
    );
    console.log("redirectBackUrl=========", redirectBackUrl);
    if (redirectBackUrl) {
      setTimeout(() => {
        console.log("Redirecting to", redirectBackUrl);
        document.cookie = `redirectBackUrl=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
        navigate(redirectBackUrl);
      }, 5000);
      return;
    }
  }, []);
  return (
    <>
      <section className="about-hero d-flex align-items-center">
        <div className="about-hero-overlay"></div>
        <div className="container-fluid container-xl px-4 px-md-3">
          <h1 className="display-5 fw-bold text-white mb-1">✅ Payment Successful</h1>
          <p className="text-light mb-0">
            Your payment has been completed.
          </p>
        </div>
      </section>

      <section id="our-story" className="py-5">
        <div style={{ textAlign: "center", marginTop: 60 }}>
          <h1>✅ Payment Successful</h1>
          <p>Your payment has been completed.</p>
          <a href="/wallet">Go to Wallet</a>
        </div>
      </section>
    </>
  );
};

export default PaymentSuccess;
